import { InjectionToken } from '@angular/core';

export const PLAUSIBLE_DOMAIN = new InjectionToken<string>('Plausible Domain');
